export const TicketBrands = {
  BYD: "BYD",
  Denza: "DENZA",
};
